import { reportTelemetryEvent } from './reportTelemetryEvent';

export type ScannerSource = 'native' | 'browser-detector' | 'browser-zxing';
export type ScannerEventType =
  | 'started'
  | 'decoded'
  | 'cancelled'
  | 'lookup_found'
  | 'lookup_not_found'
  | 'lookup_failed';

export type ScannerEvent = {
  type: ScannerEventType;
  source: ScannerSource;
  storeNo?: number | string | null;
  deviceId?: number | null;
  barcodeLength?: number;
  durationMs?: number;
};

/**
 * Records scanner lifecycle metadata, never the decoded barcode itself.
 */
export function reportScannerEvent(event: ScannerEvent): void {
  const details = [
    `source=${event.source}`,
    ...(event.storeNo !== undefined && event.storeNo !== null
      ? [`store=${event.storeNo}`]
      : []),
    ...(event.deviceId !== undefined && event.deviceId !== null
      ? [`device=${event.deviceId}`]
      : []),
    ...(event.barcodeLength !== undefined ? [`chars=${event.barcodeLength}`] : []),
  ];
  reportTelemetryEvent({
    event: 'action',
    kind: 'scanner',
    type: event.type,
    message: details.join(' | '),
    durationMs: event.durationMs,
  });
}
